import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { Link, LinkIcon } from '../../components'
import config from '../../config'
import Styles from './AboutBanner.css'

@CSSModules(Styles)
export default class AboutBanner extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props);
  }
  render() {
    return (
      <Link to={config.routes.about} title='About Fossil Free Funds'>
        <div styleName='flex'>
          <div styleName='img' title='About Fossil Free Funds'/>
          <div styleName='copy'>
            <div styleName='title'>
              Find fossil free sustainable investments
            </div>
            <div styleName='lede'>
              Built for investors who want to make a difference. Our unique dataset can help you ensure your money is making an impact.
            </div>
            <div styleName='button'>
              Learn more<LinkIcon />
            </div>
          </div>
        </div>
      </Link>
    )
  }
}

